import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-career-clusters',
  imports: [PillarPagesTemp],
  templateUrl: './career-clusters.html',
  styleUrl: './career-clusters.scss',
})
export class CareerClusters {

}
